import React from 'react';
import { useComplianceComplaints } from '../hooks/use-compliance-complaints.js';
import ComplianceComplaintsPageView from './compliance-complaints-page-view.jsx';

function ComplianceComplaintsPageContainer() {
  const state = useComplianceComplaints();
  return <ComplianceComplaintsPageView {...state} />;
}

export default ComplianceComplaintsPageContainer;
